import { useState } from 'react'
import { signInWithMemberId, wachtwoordVergeten } from '../lib/supabase'

export default function LoginPage({ onLogin }) {
  const [memberId, setMemberId] = useState('')
  const [pin, setPin] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [modus, setModus] = useState('login') // 'login' | 'vergeten' | 'verstuurd'
  const [vergeetEmail, setVergeetEmail] = useState('')
  const [vergeetLoading, setVergeetLoading] = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    if (!memberId.trim() || !pin.trim()) return
    setLoading(true); setError('')
    try {
      await onLogin(memberId.trim(), pin.trim())
    } catch {
      setError('Emailadres of wachtwoord niet herkend.')
    } finally {
      setLoading(false)
    }
  }

  async function handleVergeten(e) {
    e.preventDefault()
    if (!vergeetEmail.trim()) return
    setVergeetLoading(true)
    try {
      await wachtwoordVergeten(vergeetEmail.trim())
      setModus('verstuurd')
    } catch {
      setError('Email niet gevonden. Controleer het adres.')
    } finally {
      setVergeetLoading(false)
    }
  }

  return (
    <div className="login-page">
      {/* Header met gymfoto en logo */}
      <div style={{ position: 'relative', height: 220, flexShrink: 0 }}>
        <img
          src="/gym-header.jpg"
          alt="Vitaal Sterk"
          style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center 40%' }}
        />
        <div style={{ position: 'absolute', inset: 0, background: 'rgba(30,36,22,0.45)' }} />
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 4, background: '#e76622' }} />
        <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', padding: '0 28px' }}>
          <img src="/logo.png" alt="Vitaal Sterk" style={{ height: 120, width: 'auto', objectFit: 'contain' }} />
        </div>
      </div>

      <div className="login-body">
        {modus === 'login' && (
          <>
            <p style={{ fontFamily: 'Montserrat', fontSize: 11, color: 'var(--muted)', marginBottom: 24, textTransform: 'uppercase', letterSpacing: '0.1em' }}>
              Log in met je emailadres
            </p>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">Emailadres</label>
                <input
                  value={memberId}
                  onChange={e => setMemberId(e.target.value)}
                  placeholder="naam@email.nl"
                  autoCapitalize="none"
                  autoCorrect="off"
                  type="email"
                  inputMode="email"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Wachtwoord</label>
                <input type="password" value={pin} onChange={e => setPin(e.target.value)} placeholder="••••••" maxLength={20} />
              </div>
              {error && <p className="error-msg">{error}</p>}
              <button className="btn-primary" style={{ marginTop: 18 }} disabled={loading}>
                {loading ? 'Bezig…' : 'Inloggen'}
              </button>
            </form>
            <button
              onClick={() => { setModus('vergeten'); setError('') }}
              style={{ background: 'none', border: 'none', color: 'var(--green)', fontSize: 13, marginTop: 16, cursor: 'pointer', textDecoration: 'underline', width: '100%', textAlign: 'center' }}
            >
              Wachtwoord vergeten?
            </button>
            <div style={{ marginTop: 32, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
              <p style={{ fontSize: 10, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Powered by</p>
              <img src="/milon_logo_grey.svg" alt="Milon" style={{ height: 28, opacity: 0.5 }} />
            </div>
          </>
        )}

        {modus === 'vergeten' && (
          <>
            <p style={{ fontFamily: 'Montserrat', fontSize: 11, color: 'var(--muted)', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.1em' }}>
              Wachtwoord vergeten
            </p>
            <p style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 20, lineHeight: 1.6 }}>
              Vul je emailadres in. Je ontvangt een link om een nieuw wachtwoord aan te maken.
            </p>
            <form onSubmit={handleVergeten}>
              <div className="form-group">
                <label className="form-label">Emailadres</label>
                <input
                  type="email"
                  value={vergeetEmail}
                  onChange={e => setVergeetEmail(e.target.value)}
                  placeholder="naam@email.nl"
                  autoCapitalize="none"
                />
              </div>
              {error && <p className="error-msg">{error}</p>}
              <button className="btn-primary" style={{ marginTop: 18 }} disabled={vergeetLoading}>
                {vergeetLoading ? 'Bezig…' : 'Stuur resetlink'}
              </button>
            </form>
            <button
              onClick={() => { setModus('login'); setError('') }}
              style={{ background: 'none', border: 'none', color: 'var(--muted)', fontSize: 13, marginTop: 16, cursor: 'pointer', width: '100%', textAlign: 'center' }}
            >
              ← Terug naar inloggen
            </button>
          </>
        )}

        {modus === 'verstuurd' && (
          <>
            <div style={{ textAlign: 'center', paddingTop: 20 }}>
              <div style={{ width: 60, height: 60, borderRadius: '50%', background: 'var(--green-light)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="var(--green)" strokeWidth="2.5">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              <p style={{ fontFamily: 'Montserrat', fontWeight: 700, fontSize: 16, marginBottom: 8 }}>Email verstuurd!</p>
              <p style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.6, marginBottom: 24 }}>
                Controleer je inbox en klik op de link om een nieuw wachtwoord aan te maken.
              </p>
              <button
                onClick={() => { setModus('login'); setError('') }}
                style={{ background: 'none', border: 'none', color: 'var(--green)', fontSize: 13, cursor: 'pointer', textDecoration: 'underline' }}
              >
                ← Terug naar inloggen
              </button>
            </div>
          </>
        )}

        <div style={{ position: 'absolute', bottom: 'max(24px, calc(env(safe-area-inset-bottom) + 16px))', left: 0, right: 0, textAlign: 'center' }}>
          <p style={{ fontSize: 10, color: 'var(--muted)' }}>Laanstraat 41c · 3743 BA Baarn · 035 303 7102</p>
        </div>
      </div>
    </div>
  )
}
